export default __webpack_public_path__ + "static/media/Brittany.48925d79.jpg";